/**
 * Public pages a visitor opens as the tour website: the full player, the embed,
 * and shared demo links. The studio (login, dashboard, editor) is everything else.
 */
export function isPublicTourWebsite(pathname: string): boolean {
  const path = pathname.split('?')[0].split('#')[0].replace(/\/+$/, '') || '/';
  return /^\/(view|embed|share)(\/|$)/.test(path);
}
